export default __webpack_public_path__ + "static/media/03.de445231.jpg";